// 删除确认弹窗
<template>
  <div v-if="visible" class="delete">
    <a-modal
      v-model="visible"
      :closable="false"
      :maskClosable="false"
      :footer="null"
      :bodyStyle="bodyStyle"
      :width="436"
      @cancel="doCancle"
    >
      <div class="delete-title">
        <sass-icon type="hi-xinxitishi" style="font-size: 20px;" class="title-icon"/>
        <span class="title-font">提示</span>
      </div>
      <div class="tip-content">您的登录状态已过期，请重新登录</div>
      <div class="delete-footer">
        <a-button class="footer-comfirm" @click="doComfirm">我知道了</a-button>
        <!-- <a-button class="footer-cancle" @click="doCancle">取消</a-button> -->
      </div>
    </a-modal>
  </div>
</template>
<script>
import CommonIcon from '@/components/common-icon'
import router from '@/router'
export default {
  components: {
    CommonIcon
  },
  data () {
    return {
      bodyStyle: {
        paddingTop: '24px!important',
        paddingBottom: '24px!important',
        paddingLeft: '24px!important',
        paddingRight: '24px!important',
        height: '174px!important'
      },
      visible: false
    }
  },
  methods: {
    addOption (option) {
      this.visible = option.visible
    },
    // 点击确认
    doComfirm () {
      const { pathname } = document.location
      const isLoginPath = /\/login\/page$/.test(pathname)
      if (!isLoginPath) {
        router.push({ name: 'CommonLogin' })
      }
      this.visible = false
    },
    // 点击取消
    doCancle () {
      this.visible = false
    }
  }
}
</script>
<style lang='less' scoped>
/deep/.delete {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000000000000000000000;
  // border: 1px solid red;
}
.delete-title {
  display: flex;
  position: relative;
  height: 24px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  line-height: 24px;
  flex-direction: row;
  align-items: center;
  .title-icon {
    color: #faad14;
  }
  .title-close {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 56px;
    // text-align: center;
    line-height: 56px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    // border: 1px solid red;
  }
  .title-font {
    margin-left: 16px;
    font-family: 'PingFangSC-Medium';
    font-size: 16px;
    color: rgba(51, 51, 51, .85);
  }
}
.tip-content {
  margin-top: 13px;
  padding-left: 36px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, .85);
  .title-icon {
    margin: 0 16px 0 24px;
    vertical-align: middle;
    color: #faad14;
  }
}
.delete-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 56px;
  text-align: right;
  .footer-comfirm {
    margin-right: 24px;
    border-radius: 2px;
    height: 32px !important;
    color: #fff;
    background: #00a497;
  }
  .footer-cancles {
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    // margin-top: 12px;
    // margin-right: 24px;
    background: #fafafa;
  }
  .footer-cancle {
    // margin-top: 12px;
    margin-right: 24px;
    margin-left: 8px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    height: 32px !important;
    background: #fafafa;
  }
}
/deep/.ant-modal-content {
  width: 436px;
  height: 197px;
}
</style>
